import * as React from 'react'

import { DateSeparator } from '~publish/components/DateSeparator'
import { PostingTimeline } from '~publish/components/PostingTimeline'

import type { JSX } from 'react'

type DraftsTimelineProps<
  Undated,
  Dated extends { date: string },
> = React.ComponentPropsWithoutRef<typeof PostingTimeline> & {
  undated: readonly Undated[]
  dated: readonly Dated[]
  getKey: (draft: Undated | Dated) => string | undefined
  renderUndated: (draft: Undated) => React.ReactNode
  renderDated: (draft: Dated) => React.ReactNode
}

export function DraftsTimeline<Undated, Dated extends { date: string }>({
  undated,
  dated,
  getKey,
  renderUndated,
  renderDated,
  children,
  ...props
}: DraftsTimelineProps<Undated, Dated>): JSX.Element {
  return (
    <PostingTimeline {...props}>
      {undated.length > 0 && (
        <>
          <PostingTimeline.Header key="unscheduled-drafts-header">
            Unscheduled
          </PostingTimeline.Header>
          {undated.map((draft) => (
            <React.Fragment key={getKey(draft)}>
              {renderUndated(draft)}
            </React.Fragment>
          ))}
        </>
      )}
      {dated.map((draft, index, list) => (
        <React.Fragment key={`date-header-${getKey(draft)}`}>
          <DateSeparator
            currentDate={draft.date}
            previousDate={list[index - 1]?.date}
          />
          {renderDated(draft)}
        </React.Fragment>
      ))}
      {children}
    </PostingTimeline>
  )
}
